var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0482 13.2304L16.0573 15.8638C16.2868 16.064 16.6355 16.0408 16.8363 15.8119C17.0366 15.5823 17.0134 15.2337 16.7845 15.0328L13.8599 12.474C15.0852 11.1487 15.8345 9.37658 15.8345 7.43123C15.8345 3.32988 12.5049 0 8.40389 0C4.30254 0 0.972656 3.32957 0.972656 7.43123C0.972656 11.5323 4.30222 14.8618 8.40389 14.8618C10.1605 14.8618 11.7754 14.2511 13.0485 13.2304L13.0482 13.2304ZM8.40362 1.10352C11.8959 1.10352 14.7308 3.93888 14.7308 7.43131C14.7308 10.9236 11.8961 13.7591 8.40362 13.7591C4.91137 13.7591 2.07583 10.9237 2.07583 7.43131C2.07583 3.93906 4.91119 1.10352 8.40362 1.10352Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9ac240f984c76caa1db552b1861ca484.svg";
export { ForwardRef as ReactComponent };